import React from 'react';
import PropTypes from 'prop-types';

export const MockItem = ({ borderRadius, height, width, color }) => (
  <div
    style={{
      backgroundColor: color,
      borderRadius,
      height,
      width,
    }}
  />
);

MockItem.defaultProps = {
  borderRadius: 100,
  color: '#B9DFFE',
  height: 10,
  width: 48,
};

MockItem.propTypes = {
  borderRadius: PropTypes.number,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
